import React, { useEffect, useRef, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import './customComponents.css';
import { getCurrency, getCurrencySymbol } from '../../apps/AppContext';
import { CurrencyList } from '../../../DS-Files';
import { checkFunctionAccess } from '../../auth/AuthCheck';

interface DiscountInputProps {
  name: string;
  value?: number;
  isDiscountPct?: boolean;
  currencyId?: string;
  rememberCode?:string;
  onChange: (value: number, isDiscountPct: boolean) => void;
}

const DiscountInput: React.FC<DiscountInputProps> = ({ name, value, isDiscountPct, currencyId, onChange, rememberCode }) => {
  const [discountType, setDiscountType] = useState<boolean>(() => {
    if (rememberCode) {
      const savedType = localStorage.getItem(`discount-type-${rememberCode}`);
      return savedType !== null ? savedType === 'true' : isDiscountPct||false;
    }
    return isDiscountPct||false;
  });
  const [hasAccess, setHasAccess] = useState<boolean>(false);
  const prevIsDiscountPct = useRef<boolean | undefined>(isDiscountPct);

  useEffect(() => {
    const verifyAccess = async () => {
      const accessGranted = await checkFunctionAccess('discount');
      setHasAccess(accessGranted);
    }
    verifyAccess();
  }, [location.pathname]);

  useEffect(() => {
    if (!rememberCode) {
      setDiscountType(isDiscountPct||false);
      return;
    }
    // With rememberCode, the initial type is seeded from localStorage (see useState above),
    // so only resync when isDiscountPct actually changes afterwards (e.g. a price list
    // applies a % discount) rather than on every render/mount, which would otherwise
    // clobber the remembered manual choice.
    if (isDiscountPct !== prevIsDiscountPct.current) {
      setDiscountType(isDiscountPct||false);
      prevIsDiscountPct.current = isDiscountPct;
    }
  }, [isDiscountPct, rememberCode]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseFloat(e.target.value||'0');
    onChange(newValue, discountType);
  };
  const handleTypeChange = (isDiscountPct: boolean) => {
    setDiscountType(isDiscountPct);
    if (rememberCode) {
      localStorage.setItem(`discount-type-${rememberCode}`, isDiscountPct.toString());
    }
    onChange(value||0, isDiscountPct);
  };
  const symbol = Boolean(currencyId)
    ? CurrencyList.find(
      (currency) => currency.currencyID === currencyId
    )?.symbol
    : CurrencyList.find(
        (currency) => currency.currencyID === getCurrency()
      )?.symbol;

  const CustomToggle = React.forwardRef<HTMLSpanElement, any>(({ children, onClick }, ref) => (
    <span
      ref={ref}
      aria-expanded="false"
      className="px-3 rounded-0 cursor-pointer rounded-end input-group-text dropdown-toggle"
      id="dropdown-basic"
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
    </span>
  ));

  return (
    <div className="input-group flex-nowrap" style={{ minWidth: '50px' }}>
      <input
        type="number"
        name={name}
        disabled={!hasAccess}
        className="form-control text-end"
        value={value}
        onChange={handleInputChange}
      />
      <div className='input-group-prepend'>

        <Dropdown className="custom-dropdown">
          <Dropdown.Toggle as={CustomToggle} id="dropdown-basic">
            {discountType ? '%' : symbol}
          </Dropdown.Toggle>
          <Dropdown.Menu align="end" className="custom-dropdown-menu">
            <Dropdown.Item className="custom-dropdown-item" onClick={() => handleTypeChange(true)}>
              %
            </Dropdown.Item>
            <Dropdown.Item className="custom-dropdown-item" onClick={() => handleTypeChange(false)}>
              {symbol}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* <Dropdown className="input-group-prepend">
        <Dropdown.Toggle className='p-3 rounded-0 rounded-end input-group-text dropdown-toggle' variant="outline-secondary" id="dropdown-basic">
          {discountType ? '%' : symbol}
        </Dropdown.Toggle>

        <Dropdown.Menu align="end">
          <Dropdown.Item  onClick={() => handleTypeChange(true)}>%</Dropdown.Item>
          <Dropdown.Item  onClick={() => handleTypeChange(false)}>{symbol}</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown> */}
    </div>
  );
};

export default DiscountInput;
